import { ReactNode } from "react";
import { EntityTypeFilterValue } from "../../../legacy/types/companyFilter";

export enum CompanyTypeOption {
  GHQ = "GHQ",
  CP = "CP",
  DP = "DP",
  ALL = "ALL",
}

export type CompanyTypeDefinition = {
  value: CompanyTypeOption;
  label: string;
  tooltip: ReactNode;
};

export const COMPANY_TYPES: CompanyTypeDefinition[] = [
  {
    value: CompanyTypeOption.GHQ,
    label: "Global Headquarters (GHQ)",
    tooltip: (
      <>
        <strong>Global Headquarters (GHQ)</strong> is the highest level parent
        within a hierarchy. There is only one GHQ per organizational hierarchy,
        which can span several distinct URLs.
      </>
    ),
  },
  {
    value: CompanyTypeOption.CP,
    label: "Corporate Parent",
    tooltip: (
      <>
        <strong>Corporate Parent</strong> is the highest level parent of all
        companies with the same (normalized) URL. There can be several corporate
        parents per GHQ.
      </>
    ),
  },
  {
    value: CompanyTypeOption.DP,
    label: "Domestic Parent",
    tooltip: (
      <>
        <strong>Domestic Parent</strong> is the highest level parent within each
        country of all companies with the same (normalized) URL. This is a great
        way to view companies with unique product detections, since HG
        attributes installs to companies via URL/country.
      </>
    ),
  },
  {
    value: CompanyTypeOption.ALL,
    label: "All Entities",
    tooltip: (
      <>
        <strong>All Entities</strong> returns all parent companies and their
        subsidiaries.
      </>
    ),
  },
];

export const DEFAULT_ENTITY_TYPE_FILTER_VALUE: EntityTypeFilterValue = {
  isDp: undefined,
  isDu: undefined,
  isGhq: undefined,
  isGp: undefined,
  isGu: undefined,
};
